import { useEffect, useState } from 'react';

import { useNavigationGuard } from '../../components/NavigationGuard';
import { LeavePageModal } from '../components/LeavePageModal';
import { planningTableMessages } from '../variables/planningTableMessages';
import { useExitComponent } from './useExitComponentWithConfirmation';

export const useChangePageWithConfimation = () => {
	const { isEditing, setIsEditing } = useExitComponent();
	const [nextPath, setNextPath] = useState<string | null>(null);
	const [showLeaveModal, setShowLeaveModal] = useState(false);

	useNavigationGuard({
		when: isEditing,
		onTrigger: next => {
			setNextPath(next);
			setShowLeaveModal(true);
		},
	});

	useEffect(() => {
		const handleBeforeUnload = (e: BeforeUnloadEvent) => {
			if (isEditing) {
				e.preventDefault();
				e.returnValue = '';
			}
		};
		window.addEventListener('beforeunload', handleBeforeUnload);
		return () =>
			window.removeEventListener('beforeunload', handleBeforeUnload);
	}, [isEditing]);

	const confirmLeave = () => {
		if (nextPath) {
			window.location.href = nextPath;
		}
		setIsEditing(false);
	};

	const cancelLeave = () => {
		setNextPath(null);
		setShowLeaveModal(false);
	};

	const modal = (
		<LeavePageModal
			isOpen={showLeaveModal}
			description={planningTableMessages.MSG_LEAVE_PAGE_DESCRIPTION}
			onConfirm={confirmLeave}
			onCancel={cancelLeave}
		/>
	);

	return {
		modal,
	};
};
